<template>
  <send-email-form-component
  :contact-person-stop-sale="true"
  :send-type="EMAIL_SEND_TYPE.STOP_SALE"></send-email-form-component>
</template>
<script>
import SendEmailFormComponent from '@/views/Email/ManageEmail/components/SendEmailFormComponent'
import { EMAIL_SEND_TYPE } from '@/configs/constant'

export default {
  name: 'EmailGeneralComponent',
  components: { SendEmailFormComponent },
  data () {
    return {
      EMAIL_SEND_TYPE
    }
  }
}
</script>
